import React, { useRef, useEffect } from 'react';
import Slider from 'react-slick';

const HealthboostCarousel = ({ items, healthboostBox }) => {
    const healthboostCarouselRef = useRef(null);
    const wrapperRef = useRef(null);

    useEffect(() => {
        // Force slick to recalculate dimensions after mount or when items change
        if (healthboostCarouselRef.current && wrapperRef.current) {
            const recalculate = () => {
                if (healthboostCarouselRef.current) {
                    healthboostCarouselRef.current.slickGoTo(0, true);
                }
            };

            // Initial recalculation
            const timer1 = setTimeout(() => {
                if (healthboostCarouselRef.current) {
                    healthboostCarouselRef.current.slickGoTo(0, true);
                }
            }, 50);

            const timer2 = setTimeout(() => {
                if (healthboostCarouselRef.current) {
                    healthboostCarouselRef.current.slickGoTo(0, true);
                }
            }, 200);

            // Handle window resize
            window.addEventListener('resize', recalculate);

            return () => {
                clearTimeout(timer1);
                clearTimeout(timer2);
                window.removeEventListener('resize', recalculate);
            };
        }
    }, [items]);

    // Filter items that are valid modules (have type or moduleKey)
    const validItems = items.filter(item => item && (item['type'] || item['moduleKey']));

    // Group items into slides of 6 (2 rows x 3 columns)
    const groupedItems = [];
    for (let i = 0; i < validItems.length; i += 6) {
        groupedItems.push(validItems.slice(i, i + 6));
    }

    return (
        <div
            ref={wrapperRef}
            className="healthboost-carousel-wrapper"
            style={{
                width: '100%',
                maxWidth: '100%',
                position: 'relative',
                isolation: 'isolate',
                overflow: 'hidden'
            }}
        >
            <Slider
                className="healthboost-carousel-slider"
                ref={healthboostCarouselRef}
                infinite={groupedItems.length > 1}
                speed={500}
                slidesToShow={1}
                slidesToScroll={1}
                autoplay={false}
                arrows={false}
                dots={true}
                adaptiveHeight={false}
                variableWidth={false}
                customPaging={(i) => (
                    <div className="healthboost-carousel-dot">
                        <span className="healthboost-carousel-dot-number">{i + 1}</span>
                    </div>
                )}
                appendDots={(dots) => (
                    <ul className="healthboost-carousel-dots" style={{ margin: '0px', padding: '0px', listStyle: 'none' }}>
                        {dots}
                    </ul>
                )}
            >
                {groupedItems.map((slideItems, slideIndex) => (
                    <div key={slideIndex} className="healthboost-carousel-slide">
                        <div className="healthboost-carousel-slide-content">
                            <div className="dg gtcr3 healthboost-carousel-grid" style={{ width: '100%', gridTemplateColumns: 'repeat(3, 1fr)', boxSizing: 'border-box', rowGap: '2rem', columnGap: '1rem' }}>
                                {slideItems.map((module, itemIndex) => {
                                    return (
                                        <div key={module['type'] || module['moduleKey'] || itemIndex} className="healthboost-carousel-item" style={{ width: '100%', minWidth: 0, boxSizing: 'border-box' }}>
                                            {healthboostBox(module)}
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                ))}
            </Slider>
            {/* Custom Navigation Buttons */}
            <button
                className="healthboost-carousel-nav healthboost-carousel-prev bg3 br100 df jcc aic cp"
                onClick={() => healthboostCarouselRef.current?.slickPrev()}
                aria-label="Previous slide"
            >
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12.5 15L7.5 10L12.5 5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            </button>
            <button
                className="healthboost-carousel-nav healthboost-carousel-next bg3 br100 df jcc aic cp"
                onClick={() => healthboostCarouselRef.current?.slickNext()}
                aria-label="Next slide"
            >
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.5 5L12.5 10L7.5 15" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            </button>
        </div>
    );
};

export default HealthboostCarousel;
